module.exports = __webpack_public_path__ + "img/speak3.daaa4c23.png";